import { render, staticRenderFns } from "./editPageBanner.vue?vue&type=template&id=3d9c6538"
import script from "./editPageBanner.vue?vue&type=script&lang=js"
export * from "./editPageBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports